import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const infoColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-info-color-main'],
          highContrast: unityLightTokens['--status-info-color-high-contrast'],
          lowContrast: unityLightTokens['--status-info-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-info-color-main'],
          highContrast: unityDarkTokens['--status-info-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-info-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
